import { EventConvertHook } from './event.convert.hook'
import { ClientRepresentedEvent, ServerRepresentedEvent } from './event.model'

/**
 * Updates date timings before converting the event
 */
export class EventDatesTimingsConvertHook extends EventConvertHook {
  /**
   * Sets the hours to Hour:00:00 on each timing
   * @param event client event
   * @returns client event
   */
  beforeConvertingToServerRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    if (!event.event_timing?.length) {
      return event
    }
    const lastTiming = event.event_timing[event.event_timing.length - 1]
    const endTimeRaw = lastTiming?.end_datetime
    if (event.public_end_date != null && endTimeRaw != null && String(endTimeRaw).trim() !== '') {
      const endTime = String(endTimeRaw).split(':')
      if (endTime.length >= 2) {
        event.public_end_date.setHours(parseInt(endTime[0], 10), parseInt(endTime[1], 10), 0, 0)
      }
    }
    const startTimeRaw = event.event_timing[0]?.start_datetime
    if (startTimeRaw != null && String(startTimeRaw).trim() !== '') {
      const startTime = String(startTimeRaw).split(':')
      if (startTime.length >= 2) {
        event.public_start_date.setHours(parseInt(startTime[0], 10), parseInt(startTime[1], 10), 0, 0)
      }
    }
    return event
  }
  /**
   * stub
   * @param event server event
   * @returns server event
   */
  afterConvertingToServerRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    return event
  }
  /**
   * stub
   * @param event server event
   * @returns server event
   */
  beforeConvertingToClientRepresentedEvent(event: ServerRepresentedEvent): ServerRepresentedEvent {
    return event
  }
  /**
   * stub
   * @param event client event
   * @returns client event
   */
  afterConvertingToClientRepresentedEvent(event: ClientRepresentedEvent): ClientRepresentedEvent {
    return event
  }
}
